import React, { useEffect, useState, Fragment } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

import "../static/css/homecompanyres.css";

import empcent from "../static/images/empcent_default.png";
import krezco from "../static/images/krezco-logo.PNG";
import Modal from "react-bootstrap/Modal";
import useOnceEffect from "../Hooks/useOnceEffect";
import useToggle from '../Hooks/useToggle';




function HeaderAdmin({ profile }) 
{
  const history = useHistory();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [modalAdmin, toggleAdmin] = useToggle(false)


  const [companyData, setcompanyData] = useState("");
  
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("tok");

  let userId = localStorage.getItem("userId");
  

  useEffect(() => {
    const pp = document.getElementById("headerProfilePic");
    if (profile != null) {
      pp.src = profile;
    }

  }, [profile]);

  useOnceEffect(() => {

    axios.get("access/company/" + userId).then((result) => 
    {
      if (result.status === 200) 
      {
        setcompanyData(result.data);
      } else if (result.status === 400) {
        toast.error(
          result.errors[0].field + " " + result.errors[0].defaultMessage
        );
      } else toast.error(result.message);
    });
    
  })
  

  function logOut() {
    localStorage.clear();
    history.push("/");
  }

  function sinFuncionalidad() {
    setShow(true);
  }

  function sinFuncionalidadOk() {
    setShow(false);
  }


  const testreportCompany = () =>
  {    
    axios({
        url: "report/export/" + companyData.companyProfileId, 
        method: 'POST',
        responseType: 'blob', // important
      }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Reporte.xls`);
          document.body.appendChild(link);
          link.click();
      }).catch(function (error) {
        if (error.response.status === 403) 
        {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      });

  }

  const pp = { borderRadius: "50%" };

  const setActiveTab = (e) => {
    if (e.currentTarget.classList.value === "current") {
      e.currentTarget.classList.value = "";
    } else {
      e.currentTarget.classList.value = "current";
    }
  };

  return (
    <Fragment>
      <header className="header col-1">
        <div className="header__container container " >
          <div className="header_menu row align-items-center ">
            <div className="col-6 col-md-6 col-lg-2 header__logo header__logo--color">
              <div className="header__logoImage temp-logo">
                <img src={krezco} alt="krezco" />
              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-8 header__menu" id="header-itemconteiner">
              <ul className="list list--icons">
                <li>
                  <Link to="/admin/home">
                    <i className="fas fa-home"></i> <span id="letras">Inicio</span>
                  </Link>
                </li>
               
              </ul>
            </div>
            
            <div className="col-6 col-md-6 col-lg-2 profile__container">
              <div className="dropdown dropdown__profile">

                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    id="headerProfilePic"
                    src={empcent}
                    style={pp}
                    alt="Profile Icon"
                  ></img>
                </button>

                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >

                  <a className="dropdown-item" onClick={logOut} href="#">
                    Cerrar Sesión
                  </a>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <Modal
        show={show}
        keyboard={false}
        onHide={handleClose}
        dialogClassName="kr-modal"
      >
        <Modal.Body>
          <div className="form form--white ">
            <div className="div__wrapper">
              <div className="form__row">
                <div className="col-sm-12 ">
                  <label htmlFor="names">Funcionalidad en construcción</label>
                </div>
              </div>
              <div className="form__row">
                <button
                
                  className="btn btn--gradient btn__icon btn__icon--door"
                  onClick={() => sinFuncionalidadOk()}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <ModalAdmin show={modalAdmin} onHide={toggleAdmin} />
    </Fragment>
  );
}


function ModalAdmin({show, onHide}) {

  const [login, setLogin] = useState({
    username: '',
    password: ''
  })

  function localSubmit(e) {
    e.preventDefault()
    console.info("Sign in as admin");

  }
  
  return (
    <>
      
      <Modal
        show={show}
        keyboard={false}
        onHide={onHide}
        dialogClassName="kr-modal"
      >
        <Modal.Body>
          <div className="form form--white ">
            <div className="div__wrapper">
              <div className="form__row">
                <div className="col-sm-12 ">
                  
                  <h3 className="text-center mb-5">Verifica tu identidad para aceder al panel</h3>

                  <form onSubmit={localSubmit}>
                    <div className="form-group input-group-lg">
                      <label>Username</label>
                      <input className="form-control" value={login.username} onChange={({target}) => setLogin({...login, username: target.value})} required />
                    </div>

                    <div className="form-group input-group-lg">
                      <label>Password</label>
                      <input className="form-control" type="password" value={login.password} onChange={({target}) => setLogin({...login, password: target.value})} required />
                    </div>
                  </form>
                </div>
              </div>

              <div className="form__row">
                <button
                  className="btn btn--gradient btn__icon btn__icon--door"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default HeaderAdmin;
